import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MatDialog } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';
import {
  CLOSE_ALL_MODALS,
  CloseAllModalsAction,
} from '../actions/app.custom-actions';

/**
 * Handles closing all open modals when the CLOSE_ALL_MODALS action is dispatched.
 */
@Injectable()
export class ModalEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly dialog: MatDialog
  ) {}

  /**
   * This effect is triggered when the CLOSE_ALL_MODALS action is dispatched.
   * It will close all open Material Dialog modals.
   */
  closeAllModals$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CLOSE_ALL_MODALS),
        tap((_action: CloseAllModalsAction) => {
          // Close all open dialogs
          this.dialog.closeAll();

          console.log('[ModalEffects] Closed all modals');
        })
      ),
    { dispatch: false }
  );
}
